var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":`Manage logs`}},[_c('logs-table',_vm._b({staticClass:"logs-modal-wpapper"},'logs-table',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }